const topics = [
  {
    title: '顶流塌房实录',
    desc: '多位顶级艺人近期连环曝出丑闻，从私生活到税务问题，娱乐圈信任危机持续蔓延。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20dramatic%20stage%20with%20falling%20spotlight%2C%20broken%20mirror%20fragments%2C%20mysterious%20atmosphere%2C%20film%20noir%20style%2C%20red%20and%20black%20color%20palette%2C%20dramatic%20shadows&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '持续追踪',
    count: '36篇',
  },
  {
    title: '综艺黑幕大起底',
    desc: '选秀节目、真人秀背后的暗箱操作和潜规则，多位业内人士勇敢站出来揭露真相。',
    img: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20of%20TV%20studio%20with%20hidden%20secrets%2C%20dramatic%20lighting%2C%20mysterious%20shadows%2C%20dark%20production%20set%2C%20cinematic%20noir%20atmosphere&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '深度报道',
    count: '28篇',
  },
  {
    title: '网红圈年度大瓜',
    desc: '从带货翻车到人设崩塌，网红经济的泡沫正在破裂，真实的网红生态远比屏幕残酷。',
    img: 'https://readdy.ai/api/search-image?query=Smartphone%20screen%20cracking%20with%20social%20media%20icons%20fading%2C%20dark%20ominous%20glow%2C%20digital%20decay%20aesthetic%2C%20dramatic%20red%20and%20black%20contrast&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '热门专题',
    count: '42篇',
  },
  {
    title: '娱乐圈资本博弈',
    desc: '对赌协议、股权转让、资本运作，明星背后的商业帝国与权力游戏全揭露。',
    img: 'https://readdy.ai/api/search-image?query=Dark%20boardroom%20with%20chess%20pieces%20made%20of%20glass%2C%20dramatic%20overhead%20lighting%2C%20corporate%20intrigue%20atmosphere%2C%20red%20and%20black%20color%20scheme%2C%20mysterious%20aesthetic&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '独家揭秘',
    count: '19篇',
  },
  {
    title: '明星法律纠纷汇总',
    desc: '名誉权诉讼、合同纠纷、偷税漏税，当红艺人面临的法律挑战与案件最新进展。',
    img: 'https://readdy.ai/api/search-image?query=Legal%20documents%20scattered%20on%20dark%20desk%20with%20gavel%2C%20dramatic%20shadows%2C%20mysterious%20law%20firm%20atmosphere%2C%20noir%20cinematography%2C%20red%20wax%20seals&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '案件跟进',
    count: '24篇',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 bg-accent-500 rounded-full"></div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">焦点专题</h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {topics.map((topic, idx) => (
            <div
              key={idx}
              className="group cursor-pointer bg-background-100 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-500/30 transition-all"
            >
              <div className="relative h-40 overflow-hidden">
                <img
                  src={topic.img}
                  alt={topic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/90 via-background-50/30 to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="text-[10px] px-2 py-1 rounded-full bg-primary-500 text-background-50 font-medium">
                    {topic.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 right-3">
                  <span className="text-[10px] text-foreground-400 bg-background-100/80 px-2 py-0.5 rounded">
                    {topic.count}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-heading font-bold text-foreground-900 group-hover:text-primary-500 transition-colors text-sm mb-1.5">
                  {topic.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {topic.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}